// extracted by mini-css-extract-plugin
module.exports =  {"modalWidth":"564px","modal":"modal--Tl0Al"};